export const INPUT_MATRIX_VALUE = 'INPUT_MATRIX_VALUE' as const;
export const CLEAR_MATRIX = 'CLEAR_MATRIX' as const;
export const GENERATE_MATRIX = 'GENERATE_MATRIX' as const;
export const SET_MATRIX_SIZE = 'SET_MATRIX_SIZE' as const;
export const SOLVE_MAXIMIN_MINIMAX_SEARCH =
  'SOLVE_MAXIMIN_MINIMAX_SEARCH' as const;
export const SOLVE_REMOVING_DOMINATED_STRATEGIES =
  'SOLVE_REMOVING_DOMINATED_STRATEGIES' as const;
export const SOLVE_REMOVING_WEAK_STRATEGIES =
  'SOLVE_REMOVING_WEAK_STRATEGIES' as const;
